import brandPortalOrders from "@faire/web-api/routes/brand-portal/orders";
import brandPortalOrdersbrandOrderToken from "@faire/web-api/routes/brand-portal/orders/brandOrderToken";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
export var RequestCommissionChangesIA = function RequestCommissionChangesIA(_ref) {
  var _context$brandOrder, _context$brandOrder$b;
  var context = _ref.context;
  var brandOrderToken = (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token;
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "jm94e9",
    defaultMessage: [{
      "type": 0,
      "value": "We’re happy to update an order to 0% commission when you provide documentation of your relationship with an eligible retailer. This documentation can be submitted by going to the "
    }, {
      "children": [{
        "type": 0,
        "value": "Order details page"
      }],
      "type": 8,
      "value": "OrderDetailsLinkFormatting"
    }, {
      "type": 0,
      "value": " and navigating to "
    }, {
      "children": [{
        "type": 0,
        "value": "Request commission change"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      },
      OrderDetailsLinkFormatting: function OrderDetailsLinkFormatting(chunks) {
        return OrderLinkFormatting(chunks, brandOrderToken);
      }
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "iInC8f",
    defaultMessage: [{
      "type": 0,
      "value": "Once submitted, our team will review your request and provide you with an update via email within 2 working days. If your commission update request is approved, you’ll receive an updated commission on this order and all subsequent orders from this customer."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};
var OrderLinkFormatting = function OrderLinkFormatting(chunks, brandOrderToken) {
  if (!brandOrderToken) {
    return /*#__PURE__*/React.createElement(Button, {
      variant: "tertiary",
      linkTo: brandPortalOrders(),
      target: "_blank"
    }, /*#__PURE__*/React.createElement(Bold, null, chunks));
  } else {
    return /*#__PURE__*/React.createElement(Button, {
      variant: "tertiary",
      linkTo: brandPortalOrdersbrandOrderToken(brandOrderToken),
      target: "_blank"
    }, /*#__PURE__*/React.createElement(Bold, null, chunks));
  }
};